$(document).ready(function () {
  $(".humberger-menu a").click(function (e) {
    e.preventDefault();
    $(".humber-menu-list").slideToggle(200);
    $(this).toggleClass("active");
  });

  // Close Button Click
  $(".close-icon-mobile").click(function () {
    $(".find-car-section-wrapper-mobile").slideUp(300); // hide section
  });
  // Mobile Menu
  $(".menu_icon").click(function () {
    $(".menu").slideToggle(200);

    return false;
  });

  // Mobile Menu Icon
  $(document).ready(function () {
    $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function () {
      $(this).toggleClass("open");
    });
  });
});

// Hero section Video popup start

// ── YouTube IFrame API loader (shared across instances) ──
let ytApiReady = false;
let ytApiCallbacks = [];
function loadYouTubeAPI() {
  return new Promise((resolve) => {
    if (ytApiReady) return resolve();
    ytApiCallbacks.push(resolve);
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) return;
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);
  });
}
window.onYouTubeIframeAPIReady = function () {
  ytApiReady = true;
  ytApiCallbacks.forEach((cb) => cb());
  ytApiCallbacks = [];
};

class VideoHeroSection {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.heroType = sectionElement.dataset.heroType; // "youtube" | "native"
    this.watchBtn = sectionElement.querySelector(".btn-watch");
    this.pauseBtn = sectionElement.querySelector(".pause-btn");
    this.fullscreenBtn = sectionElement.querySelector(".fullscreen-btn");
    this.closeBtn = sectionElement.querySelector(".close-btn");
    this.heroVideo = sectionElement.querySelector(".video-background");
    this.ytContainer = sectionElement.querySelector(".yt-hero-container");
    this.overlay = sectionElement.querySelector(".overlay");
    this.content = sectionElement.querySelector(".content-hero-video");
    this.videoControls = sectionElement.querySelector(".video-controls");
    this.buttonShow = sectionElement.querySelector(".hover-show-btn");
    this.progressBar = sectionElement.querySelector(".hero-progress-bar");
    this.progressFill = sectionElement.querySelector(".progress-fill");
    this.progressHandle = sectionElement.querySelector(".progress-handle");
    this.progressTrack = sectionElement.querySelector(".progress-track");
    this.elapsedEl = sectionElement.querySelector(".progress-elapsed");
    this.durationEl = sectionElement.querySelector(".progress-duration");

    this.isExpanded = false;
    this.isPaused = false;
    this.ytPlayer = null;
    this._rafId = null;
    this._dragging = false;

    this.init();
  }

  init() {
    if (this.watchBtn) this.watchBtn.addEventListener("click", () => this.expandVideo());
    if (this.pauseBtn) this.pauseBtn.addEventListener("click", () => this.togglePause());
    if (this.fullscreenBtn) this.fullscreenBtn.addEventListener("click", () => this.toggleFullscreen());
    if (this.closeBtn) this.closeBtn.addEventListener("click", () => this.closeVideo());
    this._initScrub();

    // Pre-load YouTube API if needed (player created on Watch click)
    if (this.heroType === "youtube" && this.ytContainer) {
      loadYouTubeAPI();
    }
  }

  // ── Expand / Watch ──
  expandVideo() {
    this.isExpanded = true;
    this.overlay.classList.add("hidden");
    this.content.classList.add("hidden");
    this.videoControls.classList.add("visible");
    if (this.buttonShow) this.buttonShow.classList.add("visible");
    if (this.progressBar) this.progressBar.classList.add("visible");
    document.body.style.overflow = "hidden";

    if (this.heroType === "youtube") {
      this.ytContainer.classList.add("expanded");
      this._ensureYTPlayer(() => {
        this.ytPlayer.seekTo(0, true);
        this.ytPlayer.unMute();
        this.ytPlayer.playVideo();
        this._startProgressTick();
      });
    } else if (this.heroVideo) {
      this.heroVideo.classList.add("expanded");
      this.heroVideo.currentTime = 0;
      this.heroVideo.muted = false;
      this.heroVideo.loop = false;
      this.heroVideo.play();
      this._startProgressTick();
    }
  }

  // ── Pause / Play ──
  togglePause() {
    if (this.isPaused) {
      this._play();
      this.pauseBtn.innerHTML = `<svg fill="#000" viewBox="0 0 24 24"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>`;
      this.pauseBtn.title = "Pause";
    } else {
      this._pause();
      this.pauseBtn.innerHTML = `<svg fill="#000" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>`;
      this.pauseBtn.title = "Play";
    }
    this.isPaused = !this.isPaused;
  }

  // ── Fullscreen ──
  toggleFullscreen() {
    const el = this.heroType === "youtube" ? this.section : this.heroVideo || this.section;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      (el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen).call(el);
    }
  }

  // ── Close ──
  closeVideo() {
    this.isExpanded = false;
    this.isPaused = false;
    this.overlay.classList.remove("hidden");
    this.content.classList.remove("hidden");
    this.videoControls.classList.remove("visible");
    if (this.buttonShow) this.buttonShow.classList.remove("visible");
    if (this.progressBar) this.progressBar.classList.remove("visible");
    this._stopProgressTick();

    if (document.fullscreenElement) document.exitFullscreen();

    if (this.heroType === "youtube") {
      this.ytContainer.classList.remove("expanded");
      if (this.ytPlayer) {
        this.ytPlayer.seekTo(0, true);
        this.ytPlayer.mute();
        this.ytPlayer.playVideo(); // resume muted background loop
      }
    } else if (this.heroVideo) {
      this.heroVideo.classList.remove("expanded");
      this.heroVideo.muted = true;
      this.heroVideo.loop = true;
      this.heroVideo.currentTime = 0;
      this.heroVideo.play();
    }

    this._resetPauseBtn();
    document.querySelectorAll(".hero-section").forEach((s) => (s.style.display = ""));
    document.body.style.overflow = "";
  }

  // ── YouTube player factory ──
  _ensureYTPlayer(onReady) {
    if (this.ytPlayer) {
      onReady();
      return;
    }
    const id = this.ytContainer.dataset.youtubeId;
    if (!id) return;

    loadYouTubeAPI().then(() => {
      this.ytPlayer = new YT.Player(this.ytContainer, {
        videoId: id,
        playerVars: {
          autoplay: 1,
          controls: 0,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          loop: 1,
          playlist: id,
          mute: 1,
          playsinline: 1,
          enablejsapi: 1,
          origin: window.location.origin,
        },
        events: {
          onReady: (e) => {
            // Set attributes on the generated iframe
            const iframe = e.target.getIframe();
            iframe.setAttribute("allow", "autoplay; fullscreen");
            iframe.setAttribute("allowfullscreen", "");
            // Keep reference to the new container (YT API replaces the div)
            this.ytContainer = iframe;
            onReady();
          },
        },
      });
    });
  }

  // ── Helpers: play / pause abstraction ──
  _play() {
    if (this.heroType === "youtube" && this.ytPlayer) {
      this.ytPlayer.playVideo();
    } else if (this.heroVideo) {
      this.heroVideo.play();
    }
    this._startProgressTick();
  }

  _pause() {
    if (this.heroType === "youtube" && this.ytPlayer) {
      this.ytPlayer.pauseVideo();
    } else if (this.heroVideo) {
      this.heroVideo.pause();
    }
    this._stopProgressTick();
  }

  _resetPauseBtn() {
    if (!this.pauseBtn) return;
    this.pauseBtn.innerHTML = `<svg fill="#000" viewBox="0 0 24 24"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/></svg>`;
    this.pauseBtn.title = "Pause";
  }

  // ── Progress bar ──
  _formatTime(s) {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return m + ":" + (sec < 10 ? "0" : "") + sec;
  }

  _getCurrentTime() {
    if (this.heroType === "youtube" && this.ytPlayer) return this.ytPlayer.getCurrentTime();
    if (this.heroVideo) return this.heroVideo.currentTime;
    return 0;
  }

  _getDuration() {
    if (this.heroType === "youtube" && this.ytPlayer) return this.ytPlayer.getDuration();
    if (this.heroVideo) return this.heroVideo.duration || 0;
    return 0;
  }

  _seekTo(time) {
    if (this.heroType === "youtube" && this.ytPlayer) {
      this.ytPlayer.seekTo(time, true);
    } else if (this.heroVideo) {
      this.heroVideo.currentTime = time;
    }
  }

  _tickProgress() {
    if (!this.progressFill) return;
    const cur = this._getCurrentTime();
    const dur = this._getDuration();
    if (dur > 0) {
      const pct = (cur / dur) * 100;
      this.progressFill.style.width = pct + "%";
      if (this.progressHandle) this.progressHandle.style.left = pct + "%";
      if (this.elapsedEl) this.elapsedEl.textContent = this._formatTime(cur);
      if (this.durationEl) this.durationEl.textContent = this._formatTime(dur);
    }
    this._rafId = requestAnimationFrame(() => this._tickProgress());
  }

  _startProgressTick() {
    this._stopProgressTick();
    this._rafId = requestAnimationFrame(() => this._tickProgress());
  }

  _stopProgressTick() {
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
  }

  // ── Scrub bar drag ──
  _initScrub() {
    if (!this.progressTrack) return;

    const seek = (e) => {
      const rect = this.progressTrack.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let pct = (clientX - rect.left) / rect.width;
      pct = Math.max(0, Math.min(1, pct));
      const dur = this._getDuration();
      if (dur > 0) this._seekTo(pct * dur);
    };

    const onMove = (e) => {
      if (!this._dragging) return;
      e.preventDefault();
      seek(e);
    };

    const onUp = () => {
      if (!this._dragging) return;
      this._dragging = false;
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.removeEventListener("touchmove", onMove);
      document.removeEventListener("touchend", onUp);
      if (!this.isPaused) this._startProgressTick();
    };

    const onDown = (e) => {
      this._dragging = true;
      this._stopProgressTick();
      seek(e);
      document.addEventListener("mousemove", onMove, { passive: false });
      document.addEventListener("mouseup", onUp);
      document.addEventListener("touchmove", onMove, { passive: false });
      document.addEventListener("touchend", onUp);
    };

    this.progressTrack.addEventListener("mousedown", onDown);
    this.progressTrack.addEventListener("touchstart", onDown, { passive: false });
  }
}

// Initialize all hero sections
document.addEventListener("DOMContentLoaded", () => {
  const heroSections = document.querySelectorAll(".hero-section");
  heroSections.forEach((section) => {
    new VideoHeroSection(section);
  });
});
// Hero section Video popup end
// Section start video
document.addEventListener("DOMContentLoaded", function () {
  // Use a slight delay to ensure all videos are loaded
  setTimeout(() => {
    const yearItems = document.querySelectorAll(".year-item");

    yearItems.forEach((item) => {
      const video = item.querySelector(".video-background");
      const videoControl = item.querySelector(".video-control");

      // Check if video and controls exist
      if (!video || !videoControl) return;

      // Try to play the video
      video.play().catch((err) => {
        console.log("Autoplay prevented:", err);
      });

      videoControl.classList.add("playing");

      videoControl.addEventListener("click", (e) => {
        e.stopPropagation();
        if (video.paused) {
          video.play();
          videoControl.classList.add("playing");
        } else {
          video.pause();
          videoControl.classList.remove("playing");
        }
      });

      video.addEventListener("play", () => {
        videoControl.classList.add("playing");
      });

      video.addEventListener("pause", () => {
        videoControl.classList.remove("playing");
      });
    });
  }, 100); // Small delay to ensure DOM is fully rendered
});
// Section End video
// Scroll to top button start
const scrollButtons = document.getElementById("scrollButtons");
const returnTopBtn = document.getElementById("returnTop");
const scrollThreshold = 200;

// Show/hide buttons on scroll
window.addEventListener("scroll", () => {
  if (window.scrollY > scrollThreshold) {
    scrollButtons.classList.add("visible");
  } else {
    scrollButtons.classList.remove("visible");
  }
});

// Smooth scroll to top
returnTopBtn.addEventListener("click", (e) => {
  e.preventDefault();
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
});
// Scroll to top button end

const scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: ".scroll-spy",
  offset: 100,
});

// Scrollspy menu to section start
(function () {
  const offset = 110; // Your header height
  const navLinks = document.querySelectorAll(".nav-link");
  const sections = Array.from(navLinks)
    .map((link) => {
      const href = link.getAttribute("href");
      return href ? document.querySelector(href) : null;
    })
    .filter(Boolean);

  function setActiveLink() {
    const scrollPos = window.scrollY + offset + 1;
    let currentSection = null;

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
        currentSection = section;
      }
    });

    // Remove active from all
    navLinks.forEach((link) => link.classList.remove("active"));

    if (currentSection) {
      // সব nav-link যেগুলোর href একই সেগুলোর উপর active যোগ করা
      const activeLinks = document.querySelectorAll(`.nav-link[href="#${currentSection.id}"]`);
      activeLinks.forEach((link) => link.classList.add("active"));
    }
  }

  // smooth scroll
  navLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        const targetPosition = targetSection.offsetTop - offset;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  let ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        setActiveLink();
        ticking = false;
      });
      ticking = true;
    }
  });

  setActiveLink();
})();

// Scrollspy menu to section End

// Start scroll add class
const header = document.querySelector(".header-scroll-spy");

function checkScroll() {
  const scrollTop = window.scrollY;

  // 100 scroll হলে animation ক্লাস
  if (scrollTop > 100) {
    header.classList.add("animation");
  } else {
    header.classList.remove("animation");
  }

  // 200 scroll হলে active ক্লাস
  if (scrollTop > 200) {
    header.classList.add("active");
  } else {
    header.classList.remove("active");
  }
}
window.addEventListener("load", checkScroll);
window.addEventListener("scroll", checkScroll);

// End scroll add class
